// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.messages-container {
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  min-height: 91.4vh;
  background-color: white;
  animation: fadeIn 1s;
}
.messages-container .nav {
  margin-top: 20px;
  grid-area: 1/1/2/3;
  position: fixed;
  width: 20%;
  left: 0;
  height: 91.4vh;
}
.messages-container .form {
  grid-area: 1/3/2/11;
  overflow: hidden;
  background-color: white;
  border-radius: 15px;
  margin-right: 50px;
  margin-top: 30px;
}
.messages-container .form ::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  opacity: 0;
}
.messages-container .form:hover {
  /* Track */
  /* Handle */
  /* Handle on hover */
}
.messages-container .form:hover ::-webkit-scrollbar {
  opacity: 1;
}
.messages-container .form:hover ::-webkit-scrollbar-track {
  border-radius: 10px;
}
.messages-container .form:hover ::-webkit-scrollbar-thumb {
  background: #b4b4b4;
  border-radius: 10px;
}
.messages-container .form:hover ::-webkit-scrollbar-thumb:hover {
  background: #b4b4b4;
}
.messages-container .form .no-convo {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  animation: fadeIn 0.5s;
  font-family: "Proxima Nova", sans-serif;
}
.messages-container .form .no-convo > p {
  font-weight: 700;
  color: var(--secondary-color-1);
}
.messages-container .form .no-convo > span {
  color: var(--secondary-color-5);
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .listing-form-container .nav {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/Messages/messages.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,sCAAA;EACA,uBAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,oBAAA;AADJ;AAEI;EACI,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,OAAA;EACA,cAAA;AAAR;AAEI;EACI,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAAR;AACQ;EACI,UAAA;EACA,WAAA;EACA,UAAA;AACZ;AACQ;EAII,UAAA;EAIA,WAAA;EAKA,oBAAA;AATZ;AAHY;EACI,UAAA;AAKhB;AAFY;EACI,mBAAA;AAIhB;AADY;EACI,mBAAA;EACA,mBAAA;AAGhB;AAAY;EACI,mBAAA;AAEhB;AACQ;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,sBAAA;EACA,uCAAA;AACZ;AAAY;EACI,gBAAA;EACA,+BAAA;AAEhB;AAAY;EACI,+BAAA;AAEhB;AAGI;EACI;IAAK,UAAA;EAAX;EACM;IAAO,UAAA;EAEb;AACF;;ACrEY;EDyEJ;IAAO,aAAA;EACb;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\r\n\r\n.messages-container {\r\n    display: grid;\r\n    grid-template-columns: repeat(10, 1fr);\r\n    grid-template-rows: 1fr;\r\n    grid-column-gap: 0px;\r\n    grid-row-gap: 0px;\r\n    min-height: 91.4vh;\r\n    background-color: white;\r\n    animation: fadeIn 1s;\r\n    .nav { \r\n        margin-top: 20px;\r\n        grid-area: 1 / 1 / 2 / 3;\r\n        position: fixed;\r\n        width: 20%;\r\n        left: 0;\r\n        height: 91.4vh;\r\n    }\r\n    .form { \r\n        grid-area: 1 / 3 / 2 / 11;\r\n        overflow: hidden;\r\n        background-color: white;\r\n        border-radius: 15px;\r\n        margin-right: 50px;\r\n        margin-top: 30px;\r\n        ::-webkit-scrollbar {\r\n            width: 5px;\r\n            height: 5px;\r\n            opacity: 0;\r\n        }\r\n        &:hover {\r\n            ::-webkit-scrollbar {\r\n                opacity: 1;\r\n            }\r\n            /* Track */\r\n            ::-webkit-scrollbar-track {\r\n                border-radius: 10px;\r\n            }\r\n            /* Handle */\r\n            ::-webkit-scrollbar-thumb {\r\n                background: #b4b4b4; \r\n                border-radius: 10px;\r\n            }\r\n            /* Handle on hover */\r\n            ::-webkit-scrollbar-thumb:hover {\r\n                background: #b4b4b4; \r\n            }\r\n        }\r\n        .no-convo {\r\n            height: 100%;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            flex-direction: column;\r\n            animation: fadeIn .5s;\r\n            font-family: 'Proxima Nova', sans-serif;\r\n            > p {\r\n                font-weight: 700;\r\n                color: var(--secondary-color-1);\r\n            }\r\n            > span {\r\n                color: var(--secondary-color-5);\r\n            }\r\n        }\r\n    }\r\n\r\n    @keyframes fadeIn {\r\n        0% { opacity: 0; }\r\n        100% { opacity: 1; }\r\n    }\r\n}\r\n\r\n\r\n@include media(mobile) {\r\n    .listing-form-container {\r\n        .nav { display: none; }\r\n    }\r\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
